import { render, staticRenderFns } from "./CompanyWorkspaceNav.vue?vue&type=template&id=f03fc4e8&scoped=true"
import script from "./CompanyWorkspaceNav.vue?vue&type=script&lang=js"
export * from "./CompanyWorkspaceNav.vue?vue&type=script&lang=js"
import style0 from "./CompanyWorkspaceNav.vue?vue&type=style&index=0&id=f03fc4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03fc4e8",
  null
  
)

export default component.exports